
import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary


function AccreditationTab() {
  
  return (
    <>
      <div className="service-title font-700 mb-3">SEAFARER <span className="text-orange-ef3e33 font-400 text-uppercase">Accreditation</span>
      </div>
      
      <div className="row g-3 g-sm-4 g-md-4 g-lg-5">
        
        {/* hide left side imge column
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-lg">
          <div className="">
            {/* <p className="mb-4 font-18 font-900">
           ​​​Boating - Safety Surveys
          </p> */}

          <p className="mb-4">
            This page sets out the requirements for Accreditation of Training Institutions and Organisations as required by Part 4 of the Merchant Shipping (Training, Certification and Safe Manning) Regulations, 2021.

          </p>

          <p className="mb-4">
            All the requirements are effective on day of publication of this process, except as proved for in the transitional arrangement in the regulations or contained within the process itself.
          </p>
          <p className="mb-4">All applications for accreditation currently underway shall be completed in accordance with this process with the new requirements. For any other accreditation:</p>
          <p className="mb-4">The accreditations referred to here are in accordance with Part 4 of the Merchant Shipping (Training, Certification and Safe Manning) Regulations, 2020 (the Regulations) as well as Regulation I/6 and Section A-I/6 of the International Convention on Standards of Training, Certification and Watchkeeping for Seafarers, 1978 as amended (STCW Convention) and the Seafarers' Training and Certification Code (STCW Code), respectively</p>
          <p className="mb-4">All courses required by any Acts set out in the Schedule 2 of the South African Maritime Safety Act, 1998 shall be subject to this accreditation procedure.</p>
          <p className="mb-4">All the documents forming part of the procedure are listed below with a brief of their subject content:</p>
          </div>
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >
                   Accreditation of a training institution
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">Process, including the process flow and identification of the role players</p>

                  <ul class="green-star-ul">
                    <li><a href="#">QMS-OP-1002 - Accreditation of a training institution</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button "
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="true"
                  aria-controls="blackTabTwo"
                >Academic Courses & Programmes
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse show"
                
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">Guidance on the requirements for accrediting Academic programmes and courses</p>
                  <ul class="green-star-ul">
                    <li><a href="#">QMS-OP-1002 - Accreditation of a training institution</a></li>
                  </ul>
                   </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >Short Courses
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">Guidance on the requirements for accrediting short courses</p>
                  <ul class="green-star-ul">
                    <li><a href="#">QMS-OG-1002.1b - Short Courses</a></li>
                  </ul>
             </div>
              </div>
              
            </div>

            <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabFour"
                aria-expanded="false"
                aria-controls="blackTabFour">
            Onboard Training Programme
        </button>
    </h2>
    <div id="blackTabFour"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Guidance on the requirements for accrediting onboard training</p>

            <ul class="green-star-ul">
                <li><a href="#">QMS-OG-1002.1c - Onboard Training Programmes</a></li>
            </ul>
        </div>
    </div>
</div>
            
    <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab5"
                aria-expanded="false"
                aria-controls="blackTab5">
            Requirements for Documented Processes
        </button>
    </h2>
    <div id="blackTab5"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Requirements for training organisations to have documented processes (QMS) in place.</p>

            <ul class="green-star-ul">
                <li><a href="#">QMS-OG-1002.2 - Requirements for Documented Processes</a></li>
            </ul>
        </div>
    </div>
</div>
   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab6"
                aria-expanded="false"
                aria-controls="blackTab6">Format and Wording of Certificates
        </button>
    </h2>
    <div id="blackTab6"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Prescribed requirements for format of certificates or results issued by institutions on completion of courses. See:</p>
            <ul class="green-star-ul">
                    <li><a href="#">QMS-OT-1002.1 -​ SAMSA Accredited institution certificate</a></li>
                    <li><a href="#">QMS-OT-1002.2 - SAMSA Accredited institution certificate - radio</a></li>
                    <li><a href="#">QMS-OT-1002.3 - SAMSA Accredited institutions Statement of Academic Results</a></li>
                    <li><a href="#">QMS-OT-1002.4 - Course completed and Certs issued</a></li>
                  </ul>		

        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab7"
                aria-expanded="false"
                aria-controls="blackTab7">
            Application for Accreditation or Re-accreditation checklist
        </button>
    </h2>
    <div id="blackTab7"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Checklist for submission of information when applying for accreditation</p>
            <ul class="green-star-ul">
                <li><a href="#">QMS-OC-1002.1 - Application for Accreditation or Re-accreditation checklist</a></li>
            </ul>
        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab8"
                aria-expanded="false"
                aria-controls="blackTab8">
           Audit of a Training Provider for accreditation and re-accreditation
        </button>
    </h2>
    <div id="blackTab8"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Checklist for accreditation of a training institution – primary venue</p>
            <ul class="green-star-ul">
                <li><a href="#">QMS-OC-1002.2 - Audit of a Training Provider for accreditation and re-accreditation</a></li>
            </ul>
        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab9"
                aria-expanded="false"
                aria-controls="blackTab9">
            QMS-OC-1002.3 - Audit of a Secondary Venue for accreditation or re-accreditation
        </button>
    </h2>
    <div id="blackTab9"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Checklist for accreditation of a training institution – secondary venue</p>
            <ul class="green-star-ul">
                <li><a href="#">Audit of a Secondary Venue for accreditation or re-accreditation</a></li>
            </ul>
        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab10"
                aria-expanded="false"
                aria-controls="blackTab10">
            Adhoc Audit of a Training Provider
        </button>
    </h2>
    <div id="blackTab10"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Adhoc audit of the training institution</p>
            <ul class="green-star-ul">
                <li><a href="#">	QMS-OC-1002.4 - Adhoc Audit of a Training Provider</a></li>
            </ul>
        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab11"
                aria-expanded="false"
                aria-controls="blackTab11"> SAMSA Accredited institution certificate
        </button>
    </h2>
    <div id="blackTab11"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Template certificate issued by training institution for all courses, except radio and academic programmes and courses</p>
            <ul class="green-star-ul">
                <li><a href="#">QMS-OT-1002.1 - SAMSA Accredited institution certificate</a></li>
            </ul>
        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab12"
                aria-expanded="false"
                aria-controls="blackTab12">SAMSA Accredited institution certificate - radio
        </button>
    </h2>
    <div id="blackTab12"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Template certificate issued by training institution for all radio courses</p>
            <ul class="green-star-ul">
                <li><a href="#">QMS-OT-1002.2 - SAMSA Accredited institution certificate - radio</a></li>
            </ul>
        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab13"
                aria-expanded="false"
                aria-controls="blackTab13">
            SAMSA Accredited institutions Statement of Academic
        </button>
    </h2>
    <div id="blackTab13"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">
              Template certificate issued by training institution for academic programmes and courses</p>
            <ul class="green-star-ul">
                <li><a href="#">QMS-OT-1002.3 - SAMSA Accredited institutions Statement of Academic Results</a></li>
            </ul>
        </div>
    </div>
</div>

   <div className="accordion-item">
    <h2 className="accordion-header">
        <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab14"
                aria-expanded="false"
                aria-controls="blackTab14">
           Course completed and Certs issued
        </button>
    </h2>
    <div id="blackTab14"
         className="accordion-collapse collapse"
         data-bs-parent="#blackTab">
        <div className="accordion-body">
            <p className="mb-3">Template for the submission of course completion records</p>
            <ul class="green-star-ul">
                <li><a href="#">QMS-OT-1002.4 - Course completed and Certs issued​</a></li>
            </ul>
        </div>
    </div>
</div>

<p className="mb-4">Applications for accreditation shall be made to the nearest SAMSA office. Enquiries regarding accreditations may be directed to your nearest SAMSA Office or the Chief Examiner via e-mail to <a href="institutions@samsa.org.za">institutions@samsa.org.za</a></p>
          

            
          </div>
        </div>
        
        
      </div>
    </>
  );
}

export default AccreditationTab;